import {find, get} from 'lodash'

const defaultSelectedOffices = ''
export const selectedOffices = {
  value: defaultSelectedOffices,
}

export const getMainOfficeContactInfo = (office) =>
  find(get(office, 'office_contact_infos'), {
    office_contact_info_type: 'main_office_social',
  }) || {}

export const getLaborContactInfo = (office) =>
  find(get(office, 'office_contact_infos'), {
    office_contact_info_type: 'labor',
  }) || {}

export const getOwnerContactInfo = (office) =>
  find(get(office, 'office_contact_infos'), {
    office_contact_info_type: 'owner',
  }) || {}
